import React, { Component, Fragment } from 'react'
import { Link } from "react-router-dom";
import { Container,Row,Col, Form,Button } from 'react-bootstrap'
import Product1 from '../../assets/images/product/domainname1.png'


import Breadcrumb from 'react-bootstrap/Breadcrumb'




class domain_hosting extends Component {
     render() {
          return (
               <Fragment>

                                        
              <Container fluid={true}  className="BetweenTwoSection">
                        <div className="breadbody">
               <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to=""> Service </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/domainhosting"> Domain & Hosting </Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
               <h2 className="section-title text-center mb-2 text-primary">Domain & Hosting</h2>

<p className="text-center mb-3"> Your Website Starts with the Right Domain and Reliable Hosting</p>
                   <Row className="">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
          <img  className=""  src={Product1}  alt="ParkEase Dashboard"/>
          <Container  className="my-3">
              
                   
              
          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
            <h4>Domain & Hosting Services</h4>
          
          <p>At ChrisAlpha Tech, we provide professional domain registration and reliable web hosting services
                to help your business establish a strong online presence. Whether you're starting a new website, launching an online store, or moving an existing site, 
                we ensure your website is accessible, secure, and performs efficiently at all times.</p>

               <p>We help you choose the right domain name, set up secure hosting, and maintain 
               your website so you can focus on running your business while we handle the technical side.</p>


          <div className="">
           <h6> What is Domain and Hosting?</h6>
           
                    <p>Domain Name
          A domain name is your website’s address on the internet, such as:
          www.yourbusiness.com

          It is how customers find and identify your business online.</p>

          </div>
            <div className="">
           <h6> Web Hosting</h6>
           
                    <p>Web hosting is the service that stores your website’s files and makes 
                    them available on the internet 24/7. Without hosting, your website cannot be seen by visitors.</p>

          </div>

         
            <div className="">
           <h6> </h6>
           
      <p>We provide secure domain registration and reliable web hosting services to ensure your website is accessible, fast, and protected.
     Our team handles setup, maintenance, and support so your business stays online without interruptions.</p>

          </div>
   
          </Col>
     </Row>

</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default domain_hosting